export function smartTitle(text: string) {
  // return text;

  const minor = [
    'y',
    'de',
    'con',
    'el',
    'la',
    'los',
    'las',
    'a',
    'en',
    'por',
    'para',
    'del',
    'o',
  ];

  // Marcas y palabras que deben mantenerse en MAYÚSCULAS
  const uppercaseWords = [
    'MAF',
    'AGM',
    'EFB',
    '5G',
    '12V',
    'CCA',
    'BCI',
    'TAB',
    'D-MAX',
    'NP300',
    'HR-V',
    '4RUNNER',
    'RAV4',
    'CRV',
    'CR-V',
    'LAND ROVER',
    'AMERICAN MOTORS',
    'AM GENERAL',
    'VAM',
    'BAIC',
    'MG',
    'SMART',
    'SAAB',
    'JAC',
    'JMC',
    'GMC',
    'BMW',
  ];

  const words = text
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      // Si la palabra está en la lista de mayúsculas, mantenerla en mayúsculas
      if (uppercaseWords.includes(word.toUpperCase())) {
        return word.toUpperCase();
      }
      // Si es la primera palabra o no está en la lista de palabras menores, capitalizar
      return index === 0 || !minor.includes(word)
        ? word[0]?.toUpperCase() + word?.slice(1)
        : word;
    });

  // Quitar todos los vacios, nulos, undefined, null, etc
  return words
    .filter(
      (word) =>
        word !== '' &&
        word !== null &&
        word !== undefined &&
        word?.trim() !== '' &&
        word !== ' ' &&
        word !== '  ' &&
        word !== 'undefined' &&
        word !== 'null'
    )
    .join(' ');
}
